import { render, staticRenderFns } from "./CartPhotoBookPictureButton.vue?vue&type=template&id=cfa1e390&"
import script from "./CartPhotoBookPictureButton.vue?vue&type=script&lang=js&"
export * from "./CartPhotoBookPictureButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports